import { render, staticRenderFns } from "./moduler.vue?vue&type=template&id=a6c0936e&scoped=true"
import script from "./moduler.vue?vue&type=script&lang=js"
export * from "./moduler.vue?vue&type=script&lang=js"
import style0 from "./moduler.vue?vue&type=style&index=0&id=a6c0936e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c0936e",
  null
  
)

export default component.exports